<template>
    <body>
        <div>
            <p class="bold">发票作废申请</p>
            <hr>
        </div>
        <div class="line">
            <p><span class="required">*</span>作废原因：<input type="text" class="inp" v-model.trim="invalid_reason" /></p>
            <div class="btn">
                <input type="button" value="确定"  @click="invoiceInvalid()" >
                <input type="button" value="取消" @click="cancel()">
            </div>
        </div>
    </body>
</template>
<style scoped>
  @import '../../assets/css/pages/customer/css.css';
  body{background: #eee;}
  .bold{font-family: bold; padding-left: 5%; padding-bottom: 1em; padding-top: 1em;}
  .bes{padding-left: 5%;}
  .inp{ font-size: 0.7em; width: 65%; height: 25px;}
  .line{padding-left: 5%; padding-top: 1em;}
  .btn {padding-right: 5.5em; text-align: center;}
  .btn input {
    background-color: #5595e3;
    width: 90px;
    font-size: 10px;
    padding: 1% 1%;
    color: #fff;
    margin:3em;
  }
</style>
<script>
export default {
    data() {
        return {
            invalid_reason:'', //作废原因
        }
    },
   props: {
      order_id: {
        type: Number
      },
      invoiceInfoList:{
      }
    },
    methods:{
        invoiceInvalid() {
            this.$messageBox.confirm('是否要作废该张发票？','提示').then(() => {
                if (this.invalid_reason == null || this.invalid_reason == '') {
                    this.$msg('作废原因不能为空！', 'error', 3000)
                } else {
                    const url = "doc_app/invalid";
                    var params = {
                    order_id:this.order_id,
                    discard_reason:this.invalid_reason,
                    invoiceInfoList:this.invoiceInfoList
                    }
                    var fields = this.$myPost(url, params)
                    fields.then(res => {
                        const rcode = res.response.data.rcode
                        console.log(rcode)
                        var msg = ""
                        if (rcode == 0) {
                            this.$msg('申请作废发票成功!','success',3000)
                            this.$store.dispatch('reloadInvoiceView')
                        } else {
                            msg = res.response.data.messages[0].msg
                            this.$msg(msg, 'error', 3000)
                        }
                    }).catch(err => {
                        this.$msg('请求出错:[' + err.status + ']' + err.message,'error')
                    })
                }
            });
        },
        cancel() {
            this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', {closeDialog:true })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoiceInvalid.vue